import { createReducer, on, Action } from '@ngrx/store';
import * as contactsActions from '../actions/contact-duplicate-cell-phone.actions';
import { ContactModel } from 'src/app/core/lists/_models/contact.model';

export interface ContactState {
  selectedCellPhone: any;
  pageLoading: boolean;
  filter: { [key: string]: any };
  contacts: ContactModel[];
  totalCount: number;
}

export const initialContactState: ContactState = {
  pageLoading: false,
  filter: {},
  contacts: [],
  totalCount: 0,
  selectedCellPhone: undefined,
};

const contactReducer = createReducer(
  initialContactState,

  on(contactsActions.loadContactsSuccess, (state, { contacts, totalCount }) => ({
    ...state,
    contacts,
    totalCount,
  })),

  on(contactsActions.loadContactsFailure, (state) => ({
    ...state,
    contacts: [],
    totalCount: 0,
  })),
  on(contactsActions.resetContactsListState, (state, { saveFilter, filter }) => ({
    ...state,
    contacts: [],
    totalCount: 0,
    filter: saveFilter ? filter : {},
  })),
  on(contactsActions.toggleContactsListPageLoading, (state, { pageLoading }) => ({
    ...state,
    pageLoading,
  })),
  on(contactsActions.updateContactSuccess, (state, { contact }) => {
    const updatedContacts = state.contacts.filter((c) => c.id !== contact.id);

    return {
      ...state,
      contacts: updatedContacts,
      error: null,
    };
  }),

  on(contactsActions.updateContactFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(contactsActions.setSelectedCellPhone, (state, { cellPhone }) => ({
    ...state,
    selectedCellPhone: cellPhone,
  })),
);

export function contactListReducer(state: ContactState | undefined, action: Action): ContactState {
  return contactReducer(state, action);
}
